// ============================================================================
// OBT F2-B — Cevap medyası (fotoğraf) API katmanı (paket-yerel)
// ============================================================================
// Yeni genel upload altyapısı KURULMAZ; mevcut paylaşılan istemci kullanılır.
// Fotoğraf içeriği ACL'li uçtan blob olarak alınır; ham storage yolu/URL asla
// kullanılmaz. Object URL'ler çağıran tarafından revoke edilmelidir.
//
// Backend sözleşmesi (doğrulanmış):
//   POST /obt/responses/{id}/media/photos      → PhotoUploadResult (multipart)
//        alanlar: file (zorunlu), answer_id (opsiyonel Form)
//   GET  /obt/responses/{id}/media/{photo_id}  → görsel byte akışı (ACL)
// ============================================================================

import apiClient from '@/api/client';

const OBT = '/obt';

// Client ön-kapı sınırları — backend `obt.media` ile hizalı (nihai otorite backend).
export const MAX_PHOTO_BYTES = 10 * 1024 * 1024; // 10 MB
export const ALLOWED_PHOTO_MIME = Object.freeze([
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
]);

/**
 * POST /obt/responses/{id}/media/photos — cevaba fotoğraf ekle.
 * @param {File} file
 * @param {string|null} [answerId]  belirli bir cevaba bağlamak için (opsiyonel)
 */
export async function uploadResponsePhoto(
  responseId,
  file,
  answerId = null,
  { signal } = {}
) {
  const form = new FormData();
  form.append('file', file, file.name);
  if (answerId) form.append('answer_id', answerId);
  const res = await apiClient.post(
    `${OBT}/responses/${encodeURIComponent(responseId)}/media/photos`,
    form,
    { signal, headers: { 'Content-Type': undefined } }
  );
  return res.data; // {attachment_id, response_id, photo_id, answer_id, mime_type, attachment_type}
}

/**
 * GET /obt/responses/{id}/media/{photo_id} — ACL'li fotoğraf içeriği (blob).
 * Dönen object URL, kullanıcı arayüzünde <img src> olarak kullanılabilir ve
 * KULLANIM SONRASI `URL.revokeObjectURL` ile serbest bırakılmalıdır.
 * @returns {Promise<{objectUrl: string, mimeType: string}>}
 */
export async function readResponsePhoto(responseId, photoId, { signal } = {}) {
  const res = await apiClient.get(
    `${OBT}/responses/${encodeURIComponent(responseId)}/media/${encodeURIComponent(
      photoId
    )}`,
    { signal, responseType: 'blob' }
  );
  const blob = res.data;
  return {
    objectUrl: URL.createObjectURL(blob),
    mimeType: blob?.type || res.headers?.['content-type'] || 'image/*',
  };
}
